import { faCartShopping } from '@fortawesome/pro-solid-svg-icons';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { Badge } from '@sorare/core/src/atoms/ui/Badge';
import { NotMobileAppFeature } from '@sorare/core/src/components/BuyableFeature';
import { DialogKey } from '@sorare/core/src/components/navigation/WithDialogs';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useGenerateDialogPath } from '@sorare/core/src/hooks/navigation/useGenerateDialogPath';

import { useCart } from 'hooks/useCart';

export const NavigationCart = () => {
  const { cartCount } = useCart();
  const { sport } = useSportContext();
  const generateDialogPath = useGenerateDialogPath();
  const dialogRoute = generateDialogPath(DialogKey.checkout, sport);

  return (
    <NotMobileAppFeature>
      <Badge badgeContent={cartCount} overlap="circular" color="grey">
        <IconButton
          icon={faCartShopping}
          color="transparent"
          to={dialogRoute}
        />
      </Badge>
    </NotMobileAppFeature>
  );
};
